import { useEffect } from "react";
import { Link } from "react-router-dom";
import ExperienceSection from "../components/ExperienceSection";

export default function Page() {
  useEffect(() => {
    if (typeof window !== "undefined" && window.$) {
      const $ = window.$;
      
      // 1. Simple Counter Up
      if ($(".number1").length) {
        $.fn.$SimpleCounter = function (options) {
          var settings = $.extend({ start: 0, end: 100, easing: "swing", duration: 400, complete: "" }, options);
          var thisElement = $(this);
          $({ count: settings.start }).animate(
            { count: settings.end },
            {
              duration: settings.duration,
              easing: settings.easing,
              step: function () {
                var mathCount = Math.ceil(this.count);
                thisElement.text(mathCount);
              },
              complete: settings.complete,
            }
          );
        };
        $(".number1").$SimpleCounter({ end: 500, duration: 3000 });
        $(".number2").$SimpleCounter({ end: 350, duration: 3000 });
        $(".number3").$SimpleCounter({ end: 8, duration: 2000 });
        $(".number4").$SimpleCounter({ end: 15, duration: 2500 });
      }

      // 2. Search block
      $(".search-block").off("click").on("click", function () {
        $(".search-box").fadeToggle("slow").css({ top: "61px" });
        $(".search-block .fa").toggleClass("fa-times fa-search").addClass("fa-search");
      });

      // 3. GLightbox
      if ($(".btn_gallery").length && typeof GLightbox !== "undefined") {
        const galleryLightbox = GLightbox({ selector: ".btn_gallery" });
      }

      // 4. Hero Swiper
      if ($(".hero-slider").length && typeof Swiper !== "undefined") {
        const sliderItems = document.querySelectorAll(".slider-item");
        const container = document.querySelectorAll(".slide_img_container");
        const slice = 10;

        const swiper99 = new Swiper(".hero-slider", {
          direction: "horizontal",
          loop: true,
          autoplay: { delay: 5000, disableOnInteraction: false },
          speed: 2000,
          pagination: { el: ".swiper-pagination", type: "bullets", clickable: true },
          navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
          on: {
            slideChange: function () {
              sliderItems.forEach((item) => item.classList.remove("animate"));
              sliderItems.forEach((item) => setTimeout(() => $(item).addClass("animate"), 1000));
              splitImage("", slice, slice, container);
            },
          },
        });

        swiper99.on("slideChange", function () {
          updatePagination(this);
        });

        function updatePagination(swiper) {
          if (!swiper.slides || swiper.slides.length === 0) return;
          var currentSlide = swiper.slides[swiper.activeIndex];
          if (!currentSlide) return;
          var nextSlide = swiper.slides[(swiper.activeIndex + 1) % swiper.slides.length];
          var prevSlide = swiper.slides[(swiper.activeIndex - 1 + swiper.slides.length) % swiper.slides.length];

          var containerEl = currentSlide.querySelector(".slide_img_container");
          var currentImageSrc = containerEl ? containerEl.getAttribute("data-src") : "";
          var nextContainerEl = nextSlide.querySelector(".slide_img_container");
          var nextImageSrc = nextContainerEl ? nextContainerEl.getAttribute("data-src") : "";
          var prevContainerEl = prevSlide.querySelector(".slide_img_container");
          var prevImageSrc = prevContainerEl ? prevContainerEl.getAttribute("data-src") : "";

          var paginationBullets = document.querySelectorAll(".swiper-pagination-bullet");
          if (paginationBullets.length > swiper.activeIndex) {
            paginationBullets[swiper.activeIndex].style.backgroundImage = "url(" + currentImageSrc + ")";
          }
          var prevIndex = (swiper.activeIndex - 1 + swiper.slides.length) % swiper.slides.length;
          if (paginationBullets.length > prevIndex) {
            paginationBullets[prevIndex].style.backgroundImage = "url(" + prevImageSrc + ")";
          }
          var nextIndex = (swiper.activeIndex + 1) % swiper.slides.length;
          if (paginationBullets.length > nextIndex) {
            paginationBullets[nextIndex].style.backgroundImage = "url(" + nextImageSrc + ")";
          }
        }

        function splitImage(imageUrl, numCols, numRows, container) {
          container.forEach((item) => {
            item.innerHTML = "";
            item.classList.remove("bg-animate-duration", "bg-animate");
            for (let y = 0; y < numRows; y++) {
              for (let x = 0; x < numCols; x++) {
                const div = document.createElement("div");
                div.className = "animation-part";
                div.style.backgroundImage = `url('${imageUrl}')`;
                const posX = x * 100;
                const posY = y * 100;
                div.style.backgroundPosition = `-${posX}% -${posY}%`;
                item.appendChild(div);
              }
            }
            setTimeout(() => {
              item.classList.add("bg-animate-duration", "bg-animate");
            }, 2000);
          });
        }

        updatePagination(swiper99);
        splitImage("", slice, slice, container);
        $(".swiper-pagination-bullet").addClass("swiper-pagination-style");
      }

      // 5. Isotope Gallery
      if ($("#portfolio-filter7").length && typeof $.fn.isotope !== "undefined") {
        var $container = $("#portfolio-filter7").isotope({
          itemSelector: ".item",
          isFitWidth: true,
        });
        $(window).resize(function () {
          $container.isotope({ columnWidth: ".col-sm-3" });
        });
        $container.isotope({ filter: "*" });
        $("#filters").off("click", "button").on("click", "button", function () {
          var filterValue = $(this).attr("data-filter");
          $container.isotope({ filter: filterValue });
          $("#filters button").removeClass("active");
          $(this).addClass("active");
        });
      }

      // 6. AOS animations
      if (typeof AOS !== "undefined") {
        AOS.init({ easing: "ease-in-out-sine" });
      }

      // 7. Mobile menu toggle handlers
      const $menuArea = $(".mobile-menu-area");
      const $hamburger = $(".mobile-menu-toggle-new-line");
      const $menuClose = $(".mobile-menu-area .mobile-menu-close");
      const $menuOverlay = $(".mobile-menu-area .mobile-menu-overlay");

      $hamburger.off("click").on("click", function () {
        $menuArea.addClass("menu-open");
        $("body").css("overflow", "hidden");
        $(".line").addClass("change");
      });

      function closeMenu() {
        $menuArea.removeClass("menu-open");
        $("body").css("overflow", "");
        $(".line").removeClass("change");
      }

      $menuClose.off("click").on("click", closeMenu);
      $menuOverlay.off("click").on("click", closeMenu);

      const wrapper = document.querySelector(".mobile-menu-area .mobile-menu-wrapper");
      if (wrapper) {
        wrapper.addEventListener("click", function (e) {
          var link = e.target.closest(".menu-item-has-children > a");
          if (link) {
            e.preventDefault();
            e.stopPropagation();
            var submenu = link.nextElementSibling;
            if (submenu) {
              submenu.classList.toggle("open");
              link.closest(".menu-item-has-children").classList.toggle("submenu-open");
            }
            return;
          }
          var navLink = e.target.closest(".mobile-menu-nav > ul > li:not(.menu-item-has-children) > a, .mobile-menu-nav .sm-submenu a");
          if (navLink) {
            closeMenu();
          }
        });
      }
      
      // 8. Global Quote Modal toggle handlers
      $(".get-quote-btn").off("click").on("click", function (e) {
        e.preventDefault();
        $("#quoteModal").addClass("show");
        $("body").css("overflow", "hidden");
      });
      $(".quote-modal-close, .quote-done-btn").off("click").on("click", function () {
        $("#quoteModal").removeClass("show");
        $("body").css("overflow", "");
        $("#quoteSuccess").removeClass("show");
        $("#quoteForm").show();
      });
      $("#quoteForm").off("submit").on("submit", function(e) {
        e.preventDefault();
        // simulate success
        $(this).hide();
        $("#quoteSuccess").addClass("show");
      });
      
      // 9. FAQ accordion
      $(".faq-block-2 .accordion-list > li > .answer").hide();
      // keep first active open
      $(".faq-block-2 .accordion-list > li.active > .answer").show();
      $(".faq-block-2 .accordion-list > li").off("click").on("click", function () {
        if ($(this).hasClass("active")) {
          $(this).removeClass("active").find(".answer").slideUp();
        } else {
          $(".faq-block-2 .accordion-list > li.active .answer").slideUp();
          $(".faq-block-2 .accordion-list > li.active").removeClass("active");
          $(this).addClass("active").find(".answer").slideDown();
        }
        return false;
      });
    }
  }, []);

  return (
    <>

  <section className="page-hero" style={{ backgroundImage: "url('/assets/images/photo-1460925895917-afdab827c52f.jpg')" }}>
    <div className="page-hero-overlay"></div>
    <div className="container">
      <div className="page-hero-content">
        <div className="hero-service-icon"><i className="fa fa-images"></i></div>
        <h1>Project Portfolio</h1>
        <nav className="breadcrumb-nav" aria-label="breadcrumb">
          <Link to="/">Home</Link><span className="sep">/</span>
          <span className="current">Gallery</span>
        </nav>
      </div>
    </div>
  </section>
  <ExperienceSection />
    <section id="gallery" className="gallery-1 gallery-no-slider pt-60 pb-60">
      
      <div className="section-bg-images">
        <div className="bg-img size-medium top-left" style={{ backgroundImage: "url('/vector-svg-shapes/63-diamond.svg')" }} data-aos="flip-down" data-aos-delay="100" data-aos-duration="800"></div>
        <div className="bg-img size-small top-center" style={{ backgroundImage: "url('/vector-svg-shapes/74-drop.svg')" }} data-aos="rotate-left" data-aos-delay="200" data-aos-duration="1000"></div>
        <div className="bg-img size-medium top-right" style={{ backgroundImage: "url('/vector-svg-shapes/42-hexagon.svg')" }} data-aos="rotate-right" data-aos-delay="300" data-aos-duration="1200"></div>
        <div className="bg-img size-small center-left" style={{ backgroundImage: "url('/vector-svg-shapes/90-home.svg')" }} data-aos="fade-up" data-aos-delay="400" data-aos-duration="1400"></div>
        <div className="bg-img size-medium center-center" style={{ backgroundImage: "url('/vector-svg-shapes/95-layered-circles.svg')" }} data-aos="fade-down" data-aos-delay="500" data-aos-duration="800"></div>
        <div className="bg-img size-small center-right" style={{ backgroundImage: "url('/vector-svg-shapes/91-eye.svg')" }} data-aos="fade-left" data-aos-delay="600" data-aos-duration="1000"></div>
        <div className="bg-img size-medium bottom-left" style={{ backgroundImage: "url('/vector-svg-shapes/47-hexagon-outline.svg')" }} data-aos="fade-right" data-aos-delay="700" data-aos-duration="1200"></div>
        <div className="bg-img size-small bottom-center" style={{ backgroundImage: "url('/vector-svg-shapes/84-rounded-leaf.svg')" }} data-aos="zoom-in" data-aos-delay="800" data-aos-duration="1400"></div>
        <div className="bg-img size-medium bottom-right" style={{ backgroundImage: "url('/vector-svg-shapes/12-circle-outline.svg')" }} data-aos="zoom-out" data-aos-delay="900" data-aos-duration="800"></div>
      </div>
      <div className="container">

        <div className="ebl-data-blocks">
          <div className="comingsoon-body-item block-item text-center" data-aos="fade-down" data-aos-delay="100">
            <div className="subtitle">
              <h4>
                <span></span>
                <span>Our Portfolio</span>
                <span></span>
              </h4>
            </div>
          </div>
          <div className="comingsoon-body-item block-item text-center" data-aos="fade-down" data-aos-delay="200">
            <div className="title title_1bececf">
              <h2>
                <span></span>
                <span>Recent Projects & Completed Work</span>
                <span></span>
              </h2>
            </div>
          </div>

          <div className="comingsoon-body-item block-item text-center" data-aos="fade-down" data-aos-delay="300">
            <div className="plain_text plain_text_1bececf">
              <p>
                Take a look at our portfolio of completed projects showcasing our
                quality execution across web applications, cloud hosting, and enterprise integrations.
              </p>
            </div>
          </div>

          <div className="comingsoon-body-item block-item mt-3">
            <div className="gallery">
              <div className="gallery_grid swiper gallery-swiper">
                <div className="swiper-wrapper row">
                  <div className="swiper-slide col-lg-4 col-sm-6" data-aos="flip-left" data-aos-delay="100">
                    <div className="gallery_single">
                      <div className="gallery_img">
                        <img
                          src="/assets/images/photo-1460925895917-afdab827c52f.jpg"
                          alt="FinTech Web App" />
                      </div>
                      <div className="gallery_overlay">
                        <h3><a href="#">FinTech Web App</a></h3>
                        <div className="gal-cat">Web &amp; App</div>
                        <div className="item-btn">
                          <a href="/assets/images/photo-1460925895917-afdab827c52f.jpg"
                            className="btn_gallery">+</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="swiper-slide col-lg-4 col-sm-6" data-aos="flip-right" data-aos-delay="200">
                    <div className="gallery_single">
                      <div className="gallery_img">
                        <img
                          src="/assets/images/photo-1512941937669-90a1b58e7e9c.jpg"
                          alt="E-Commerce App UX" />
                      </div>
                      <div className="gallery_overlay">
                        <h3><a href="#">E-Commerce App UX</a></h3>
                        <div className="gal-cat">UI/UX Design</div>
                        <div className="item-btn">
                          <a href="/assets/images/photo-1512941937669-90a1b58e7e9c.jpg"
                            className="btn_gallery">+</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="swiper-slide col-lg-4 col-sm-6" data-aos="flip-left" data-aos-delay="300">
                    <div className="gallery_single">
                      <div className="gallery_img">
                        <img
                          src="/assets/images/photo-1551288049-bebda4e38f71.jpg"
                          alt="AWS Cloud Migration" />
                      </div>
                      <div className="gallery_overlay">
                        <h3><a href="#">AWS Cloud Migration</a></h3>
                        <div className="gal-cat">Cloud &amp; DevOps</div>
                        <div className="item-btn">
                          <a href="/assets/images/photo-1551288049-bebda4e38f71.jpg"
                            className="btn_gallery">+</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="swiper-slide col-lg-4 col-sm-6" data-aos="flip-right" data-aos-delay="400">
                    <div className="gallery_single">
                      <div className="gallery_img">
                        <img
                          src="/assets/images/photo-1563986768609-322da13575f3.jpg"
                          alt="Security Audit" />
                      </div>
                      <div className="gallery_overlay">
                        <h3><a href="#">Security Audit</a></h3>
                        <div className="gal-cat">Cybersecurity</div>
                        <div className="item-btn">
                          <a href="/assets/images/photo-1563986768609-322da13575f3.jpg"
                            className="btn_gallery">+</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="swiper-slide col-lg-4 col-sm-6" data-aos="flip-left" data-aos-delay="500">
                    <div className="gallery_single">
                      <div className="gallery_img">
                        <img
                          src="/assets/images/photo-1544383835-bda2bc66a55d.jpg"
                          alt="Big Data Processing" />
                      </div>
                      <div className="gallery_overlay">
                        <h3><a href="#">Big Data Processing</a></h3>
                        <div className="gal-cat">AI &amp; Data</div>
                        <div className="item-btn">
                          <a href="/assets/images/photo-1544383835-bda2bc66a55d.jpg"
                            className="btn_gallery">+</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="swiper-slide col-lg-4 col-sm-6" data-aos="flip-right" data-aos-delay="600">
                    <div className="gallery_single">
                      <div className="gallery_img">
                        <img
                          src="/assets/images/photo-1558494949-ef010cbdcc31.jpg"
                          alt="High-Speed VPS Setup" />
                      </div>
                      <div className="gallery_overlay">
                        <h3><a href="#">High-Speed VPS Setup</a></h3>
                        <div className="gal-cat">Server Management</div>
                        <div className="item-btn">
                          <a href="/assets/images/photo-1558494949-ef010cbdcc31.jpg"
                            className="btn_gallery">+</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="swiper-navigation no-slider no-nav">
                  <div className="swiper-button-prev"></div>
                  <div className="swiper-pagination"></div>
                  <div className="swiper-button-next"></div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>

    

    <section className="tab-gallery-1 pt-60 pb-60">
      
      <div className="section-bg-images">
        <div className="bg-img size-medium top-left" style={{ backgroundImage: "url('/vector-svg-shapes/20-circle-ring.svg')" }} data-aos="flip-down" data-aos-delay="100" data-aos-duration="800"></div>
        <div className="bg-img size-small top-center" style={{ backgroundImage: "url('/vector-svg-shapes/47-hexagon-outline.svg')" }} data-aos="rotate-left" data-aos-delay="200" data-aos-duration="1000"></div>
        <div className="bg-img size-medium top-right" style={{ backgroundImage: "url('/vector-svg-shapes/87-trophy.svg')" }} data-aos="rotate-right" data-aos-delay="300" data-aos-duration="1200"></div>
        <div className="bg-img size-small center-left" style={{ backgroundImage: "url('/vector-svg-shapes/44-octagon.svg')" }} data-aos="fade-up" data-aos-delay="400" data-aos-duration="1400"></div>
        <div className="bg-img size-medium center-center" style={{ backgroundImage: "url('/vector-svg-shapes/94-star-badge.svg')" }} data-aos="fade-down" data-aos-delay="500" data-aos-duration="800"></div>
        <div className="bg-img size-small center-right" style={{ backgroundImage: "url('/vector-svg-shapes/75-shield.svg')" }} data-aos="fade-left" data-aos-delay="600" data-aos-duration="1000"></div>
        <div className="bg-img size-medium bottom-left" style={{ backgroundImage: "url('/vector-svg-shapes/64-diamond-outline.svg')" }} data-aos="fade-right" data-aos-delay="700" data-aos-duration="1200"></div>
        <div className="bg-img size-small bottom-center" style={{ backgroundImage: "url('/vector-svg-shapes/78-ribbon.svg')" }} data-aos="zoom-in" data-aos-delay="800" data-aos-duration="1400"></div>
        <div className="bg-img size-medium bottom-right" style={{ backgroundImage: "url('/vector-svg-shapes/83-rounded-squircle.svg')" }} data-aos="zoom-out" data-aos-delay="900" data-aos-duration="800"></div>
      </div>
      <div className="container">

        <div className="ebl-data-blocks">

          <div className="comingsoon-body-item block-item  text-center" data-aos="fade-down" data-aos-delay="100">
            <div className="subtitle subtitle_1bececf">
              <h4>
                <span className="subtitle-first-span"></span>
                <span className="subtitle-middle-span">Our Work</span>
                <span className="subtitle-last-span"></span>
              </h4>
            </div>
          </div>
          <div className="comingsoon-body-item block-item  text-center" data-aos="fade-down" data-aos-delay="200">
            <div className="title title_1bececf">
              <h2>
                <span></span>
                <span>Project Showcase</span>
                <span></span>
              </h2>
            </div>
          </div>
          <div className="comingsoon-body-item block-item">
            <div className="recent-work">
              <div className="recent-work-wrap">
                <div className="row justify-content-center mb-5 aos-init aos-animate" data-aos="fade-up">
                  <div id="filters" className="filters text-center button-group col-md-7">
                    <button className="btn active" data-filter="*">All</button>
                    <button className="btn" data-filter=".software">Software</button>
                    <button className="btn" data-filter=".cloud">Cloud &amp; DevOps</button>
                    <button className="btn" data-filter=".vps">VPS &amp; Hosting</button>
                    <button className="btn" data-filter=".design">UI/UX Design</button>
                  </div>
                </div>
                <div className="recent-work-grid row" id="portfolio-filter7">
                  <div className="work-grid-wrap item software col-lg-3 col-md-4 col-sm-6" data-aos="flip-left"
                    data-aos-delay="100">
                    <a href="#" className="work-box">
                      <img src="/assets/images/photo-1551288049-bebda4e38f71.jpg"
                        alt="ERP Platform" />
                      <div className="work-box-content hover-content">
                        <h3>CRM/ERP Platform</h3>
                        <span className="work-category">Enterprise Software</span>
                      </div>
                    </a>
                  </div>
                  <div className="work-grid-wrap item cloud col-lg-3 col-md-4 col-sm-6" data-aos="flip-right"
                    data-aos-delay="150">
                    <a href="#" className="work-box">
                      <img src="/assets/images/photo-1451187580459-43490279c0fa.jpg"
                        alt="AWS Cloud Migration" />
                      <div className="work-box-content hover-content">
                        <h3>AWS Cloud Migration</h3>
                        <span className="work-category">Cloud &amp; DevOps</span>
                      </div>
                    </a>
                  </div>
                  <div className="work-grid-wrap item vps col-lg-3 col-md-4 col-sm-6" data-aos="flip-left"
                    data-aos-delay="300">
                    <a href="#" className="work-box">
                      <img src="/assets/images/photo-1558494949-ef010cbdcc31.jpg"
                        alt="E-Commerce VPS Setup" />
                      <div className="work-box-content hover-content">
                        <h3>E-Commerce VPS Setup</h3>
                        <span className="work-category">VPS &amp; Hosting</span>
                      </div>
                    </a>
                  </div>
                  <div className="work-grid-wrap item design col-lg-3 col-md-4 col-sm-6" data-aos="flip-right"
                    data-aos-delay="400">
                    <a href="#" className="work-box">
                      <img src="/assets/images/photo-1512941937669-90a1b58e7e9c.jpg"
                        alt="E-Comm Mobile App" />
                      <div className="work-box-content hover-content">
                        <h3>E-Comm Mobile App</h3>
                        <span className="work-category">UI/UX Design</span>
                      </div>
                    </a>
                  </div>
                  <div className="work-grid-wrap item software col-lg-3 col-md-4 col-sm-6" data-aos="flip-left"
                    data-aos-delay="500">
                    <a href="#" className="work-box">
                      <img src="/assets/images/photo-1460925895917-afdab827c52f.jpg"
                        alt="SaaS Dashboard" />
                      <div className="work-box-content hover-content">
                        <h3>SaaS Dashboard</h3>
                        <span className="work-category">Web Application</span>
                      </div>
                    </a>
                  </div>
                  <div className="work-grid-wrap item design col-lg-3 col-md-4 col-sm-6" data-aos="flip-left"
                    data-aos-delay="600">
                    <a href="#" className="work-box">
                      <img src="/assets/images/photo-1531403009284-440f080d1e12.jpg"
                        alt="Interactive Prototyping" />
                      <div className="work-box-content hover-content">
                        <h3>Interactive Prototyping</h3>
                        <span className="work-category">UI/UX Design</span>
                      </div>
                    </a>
                  </div>
                  <div className="work-grid-wrap item cloud col-lg-3 col-md-4 col-sm-6" data-aos="flip-right"
                    data-aos-delay="200">
                    <a href="#" className="work-box">
                      <img src="/assets/images/photo-1563986768609-322da13575f3.jpg"
                        alt="CI/CD Automation" />
                      <div className="work-box-content hover-content">
                        <h3>CI/CD Automation</h3>
                        <span className="work-category">Cloud &amp; DevOps</span>
                      </div>
                    </a>
                  </div>
                  <div className="work-grid-wrap item vps col-lg-3 col-md-4 col-sm-6" data-aos="flip-left"
                    data-aos-delay="800">
                    <a href="#" className="work-box">
                      <img src="/assets/images/photo-1600132806370-bf17e65e942f.jpg"
                        alt="Server Clustering" />
                      <div className="work-box-content hover-content">
                        <h3>Server Clustering</h3>
                        <span className="work-category">VPS &amp; Hosting</span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    
    
    </>
  );
}
